import { actions } from '../../../utils/constants';

export const getRank = () => ({
  type: actions.FETCH_RANK_START
})



// WEBPACK FOOTER //
// ./src/App/containers/ranking/ranking.actions.js